'use strict';

import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Notes = {

    async createNew(userID, note) {
        try {
            if (!userID || !note) {
                return { error: 'A mandatory field is missing' }
            }

            let header = await getHeader();
            let response = await axios.post(API_URL + '/note', {
                "userId": userID,
                "note": note
            }, header);

            return !response.data.id ? false : response.data;

        } catch(error) {
            return false;
        }
    },

    async getByUserID(userID) {
        try {
            if (!userID) {
                return { error: "User ID is missing" }
            }

            let header = await getHeader();

            let response = await axios.get(API_URL + '/notes/' + userID, header);
            
            return response.data;

        } catch(error) {
            return false;
        }
    },

    async update(noteID, note) {
        try {
            if (!noteID || !note) {
                return { error: 'A mandatory field is missing' }
            }

            let header = await getHeader();

            let response = await axios.patch(API_URL + '/note/' + noteID, {
                "note": note
            }, header);

            return !response.data.id ? false : response.data;

        } catch(error) {
            return false;
        }
    }

    
}

export default Notes;
